import { FunnelStartedFields, TestStartedFields, UserClickFields, ViewContentFields } from '@xylabs/pixel'
import { XyCustomEvent } from '@xylabs/react-pixel'

import { AddressInfoData, ContactInfoData } from 'business-logic/cart/models'

export interface CoinContactInfoComplete extends ContactInfoData, Record<string, unknown> {}
export interface CoinAddressInfoComplete extends AddressInfoData, Record<string, unknown> {}

export class CoinEvents<T extends Record<string, unknown>> {
  public addToCart() {
    return new XyCustomEvent<CoinContactInfoComplete | T>('AddToCart')
  }

  public purchase() {
    return new XyCustomEvent<CoinContactInfoComplete | T>('Purchase')
  }

  public initiateCheckout() {
    return new XyCustomEvent<CoinContactInfoComplete | T>('InitiateCheckout')
  }

  public contactInfoComplete() {
    return new XyCustomEvent<CoinContactInfoComplete | T>('ContactInfoComplete')
  }

  public addressInfoComplete() {
    return new XyCustomEvent<CoinAddressInfoComplete | T>('AddressInfoComplete')
  }

  public paymentInfoComplete() {
    return new XyCustomEvent<T>('PaymentInfoComplete')
  }

  public transactionAttempted() {
    return new XyCustomEvent<T>('TransactionAttempted')
  }

  public transactionFailed() {
    return new XyCustomEvent<T>('TransactionFailed')
  }

  public transactionCompleted() {
    return new XyCustomEvent<T>('TransactionCompleted')
  }

  public trialStarted() {
    return new XyCustomEvent<T>('TrialStarted')
  }

  public upsellViewed() {
    return new XyCustomEvent<T>('UpsellViewed')
  }

  public upsellUnavailable() {
    return new XyCustomEvent<T>('UpsellUnavailable')
  }

  public upsellAccepted() {
    return new XyCustomEvent<T>('UpsellAccepted')
  }

  public upsellSucceeded() {
    return new XyCustomEvent<T>('UpsellSucceeded')
  }

  public upsellFailed() {
    return new XyCustomEvent<T>('UpsellFailed')
  }

  public testStarted() {
    return new XyCustomEvent<TestStartedFields | T>('TestStarted')
  }

  public userClick() {
    return new XyCustomEvent<UserClickFields | T>('UserClick')
  }

  public viewContent() {
    return new XyCustomEvent<ViewContentFields | T>('ViewContent')
  }

  public funnelStarted() {
    return new XyCustomEvent<FunnelStartedFields | T>('FunnelStarted')
  }

  public emailCollected() {
    return new XyCustomEvent<{ email: string } | T>('EmailCollected')
  }

  public accountCreated() {
    return new XyCustomEvent<T>('AccountCreated')
  }

  public shareCompleted() {
    return new XyCustomEvent<T>('ShareCompleted')
  }

  public funnelCompleted() {
    return new XyCustomEvent<T>('FunnelCompleted')
  }

  public buyticketsCompleted() {
    return new XyCustomEvent<T>('BuyTicketsCompleted')
  }

  public installCompleted() {
    return new XyCustomEvent<T>('InstallCompleted')
  }

  public offerRequested() {
    return new XyCustomEvent<{ id: string } | T>('OfferRequested')
  }

  public feedbackScoreCollected() {
    return new XyCustomEvent<{ score: string | number } | T>('FeedbackScoreCollected')
  }

  public feedbackSourceCollected() {
    return new XyCustomEvent<{ source: string } | T>('FeedbackSourceCollected')
  }

  public goodFeedbackRequested() {
    return new XyCustomEvent<T>('GoodFeedbackRequested')
  }

  public badFeedbackRequested() {
    return new XyCustomEvent<T>('BadFeedbackRequested')
  }

  public customEvent(name: string) {
    return new XyCustomEvent<T>(name)
  }
}
